import { ContactDealerPopoverContentProps } from '../../types';

export const ContactDealerPopoverContent = ({
  className,
  children
}: ContactDealerPopoverContentProps) => {
  return <div data-testid='contact_dealer_content' className={className}>{children}</div>;
};
